/**
 * Central locale loader.
 *
 * translation.json was split by domain into smaller files
 * (tour / copilot / landing / board / profile / help / common-*).
 * Everything is merged back into the single "translation" namespace
 * so existing t("Key") calls keep working unchanged.
 *
 * Rule: when adding a new key, add it to the matching domain file
 * (or the correct common-{letter-range} file) — never recreate translation.json.
 */
import enBoard from "./en/board.json";
import enCommonAF from "./en/common-a-f.json";
import enCommonGM from "./en/common-g-m.json";
import enCommonNS from "./en/common-n-s.json";
import enCommonTZ from "./en/common-t-z.json";
import enCopilot from "./en/copilot.json";
import enEnterprise from "./en/enterprise.json";
import enHelp from "./en/help.json";
import enInvoiceMaker from "./en/invoicemaker.json";
import enLanding from "./en/landing.json";
import enProfile from "./en/profile.json";
import enTour from "./en/tour.json";

import faBoard from "./fa/board.json";
import faCommonAF from "./fa/common-a-f.json";
import faCommonGM from "./fa/common-g-m.json";
import faCommonNS from "./fa/common-n-s.json";
import faCommonTZ from "./fa/common-t-z.json";
import faCopilot from "./fa/copilot.json";
import faEnterprise from "./fa/enterprise.json";
import faHelp from "./fa/help.json";
import faInvoiceMaker from "./fa/invoicemaker.json";
import faLanding from "./fa/landing.json";
import faProfile from "./fa/profile.json";
import faTour from "./fa/tour.json";

const en = {
  ...enBoard,
  ...enCommonAF,
  ...enCommonGM,
  ...enCommonNS,
  ...enCommonTZ,
  ...enCopilot,
  ...enEnterprise,
  ...enHelp,
  ...enInvoiceMaker,
  ...enLanding,
  ...enProfile,
  ...enTour,
};

const fa = {
  ...faBoard,
  ...faCommonAF,
  ...faCommonGM,
  ...faCommonNS,
  ...faCommonTZ,
  ...faCopilot,
  ...faEnterprise,
  ...faHelp,
  ...faInvoiceMaker,
  ...faLanding,
  ...faProfile,
  ...faTour,
};

export const localeResources = { en, fa };
